import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as ChevronLeftIcon } from '../../assets/images/svg/chevron-left.svg';
import themeColors from '../../assets/styles/themeColors';

const ChevronLeftIconStyled = styled(ChevronLeftIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const ChevronLeft = (props) => <ChevronLeftIconStyled {...props} />;

ChevronLeft.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

ChevronLeft.defaultProps = {
  w: '8px',
  h: '14px',
};

export default ChevronLeft;
